import React from 'react'
import { withStyles } from '@mui/styles'
import { Checkbox } from '@mui/material'

const GreenCheckbox = withStyles({
  root: {
    color: '#e2e8ee',
    borderRadius: '6px',
    '&$checked': {
      color: '#29cc8b',
    },
  },
  checked: {},
})((props) => <Checkbox color='default' {...props} />)

export default GreenCheckbox
